import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PWAPrompt, useInstallPrompt } from "@/components/PWAPrompt";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "./pages/Home";
import Associazione from "./pages/Associazione";
import Tesseramento from "./pages/Tesseramento";
import Attivita from "./pages/Attivita";
import Castelli from "./pages/Castelli";
import LAquilaCecilia from "./pages/LAquilaCecilia";
import Documenti from "./pages/Documenti";
import Trasparenza from "./pages/Trasparenza";
import Attestati from "./pages/Attestati";
import Amici from "./pages/Amici";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TerminiServizio from "./pages/TerminiServizio";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Componente wrapper per gli hooks PWA
const PWAInstallHandler = () => {
  useInstallPrompt();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <PWAPrompt />
      <PWAInstallHandler />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/associazione" element={<Associazione />} />
          <Route path="/tesseramento" element={<Tesseramento />} />
          <Route path="/attivita" element={<Attivita />} />
          <Route path="/castelli" element={<Castelli />} />
          <Route path="/laquila-cecilia" element={<LAquilaCecilia />} />
          <Route path="/documenti" element={<Documenti />} />
          <Route path="/trasparenza" element={<Trasparenza />} />
          <Route path="/attestati" element={<Attestati />} />
          <Route path="/amici" element={<Amici />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/termini" element={<TerminiServizio />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
